var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareNetwork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ShareNetwork"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3 7.5C3.82843 7.5 4.5 6.82843 4.5 6C4.5 5.17157 3.82843 4.5 3 4.5C2.17157 4.5 1.5 5.17157 1.5 6C1.5 6.82843 2.17157 7.5 3 7.5Z",
    stroke: "#272727",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.25 10.875C9.07843 10.875 9.75 10.2034 9.75 9.375C9.75 8.54657 9.07843 7.875 8.25 7.875C7.42157 7.875 6.75 8.54657 6.75 9.375C6.75 10.2034 7.42157 10.875 8.25 10.875Z",
    stroke: "#272727",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M8.25 4.125C9.07843 4.125 9.75 3.45343 9.75 2.625C9.75 1.79657 9.07843 1.125 8.25 1.125C7.42157 1.125 6.75 1.79657 6.75 2.625C6.75 3.45343 7.42157 4.125 8.25 4.125Z",
    stroke: "#272727",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M6.98887 3.43555L4.26074 5.18867",
    stroke: "#272727",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M4.26074 6.81055L6.98887 8.56367",
    stroke: "#272727",
    strokeWidth: 0.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareNetwork);
export default __webpack_public_path__ + "static/media/share-network.dccbc3212dbf7c78274755c53e6d0b9e.svg";
export { ForwardRef as ReactComponent };